import { render, staticRenderFns } from "./dragVierity.vue?vue&type=template&id=c03b0b74&scoped=true&"
import script from "./dragVierity.vue?vue&type=script&lang=js&"
export * from "./dragVierity.vue?vue&type=script&lang=js&"
import style0 from "./dragVierity.vue?vue&type=style&index=0&id=c03b0b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b0b74",
  null
  
)

export default component.exports